<template>
  <BaseCard
    :heading="filters.capitalize(t('global.actions.send_to_customer'))"
    v-model:toggle="sendInvoice"
    v-test="'issue-invoice-email-card'"
  >
    <Form
      v-if="sendInvoice"
      v-model:emailAddress="email"
      v-model:emailSubject="subject"
      v-model:editorContent="content"
      :editorHeight="200"
    />
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import filters from '@/filters';
import Form from '@/modals/sale-email/Form.vue';

const { t } = useI18n();

const props = defineProps<{
  email: string;
  subject: string;
  content: string;
  sendInvoice: boolean;
}>();

const emit = defineEmits<{
  (e: 'update:email', value: string): void;
  (e: 'update:subject', value: string): void;
  (e: 'update:content', value: string): void;
  (e: 'update:sendInvoice', value: boolean): void;
}>();

const email = computed({
  get: () => props.email,
  set: (value) => emit('update:email', value),
});

const subject = computed({
  get: () => props.subject,
  set: (value) => emit('update:subject', value),
});

const content = computed({
  get: () => props.content,
  set: (value) => emit('update:content', value),
});

const sendInvoice = computed({
  get: () => props.sendInvoice,
  set: (value) => emit('update:sendInvoice', value),
});
</script>
